export default __webpack_public_path__ + "static/media/check.c97e48be.svg";